import Tooltip from './Tooltip';

export default Tooltip;


//////////////////
// WEBPACK FOOTER
// ../~/rc-tooltip/es/index.js
// module id = 2734
// module chunks = 1